import React from "react";
import OnboardingLayout from "component/auth/OnboardingLayout";
import Loader from "component/loader";
import { RequirementFieldRenderer } from "./updateInformation/RequirementFields";
import { useUpdateInformation } from "./updateInformation/useUpdateInformation";

const UpdateInformation = () => {
  const {
    renderableRequirements,
    values,
    files,
    configLoading,
    loading,
    error,
    canSubmit,
    country,
    countryOptions,
    kybCountriesLoading,
    phoneCountryCode,
    phoneCountryOptions,
    countriesLoading,
    phoneError,
    getPhoneDialCode,
    setPhoneCountryTouched,
    setPhoneCountryCode,
    setPhoneError,
    updateValue,
    updateAddress,
    handleFileChange,
    removeFile,
    handleUpdateMoreData,
    handleSubmit,
  } = useUpdateInformation();

  return (
    <OnboardingLayout title="Update information" steps={[]} showSkip={false}>
      <div className="max-w-[650px] mx-auto w-full">
        <h1 className="aku-heading-h2-medium text-[#101828]">
          Update your information
        </h1>

        {configLoading ? (
          <div className="flex justify-center py-16">
            <Loader />
          </div>
        ) : (
          <div className="mt-8 space-y-4">
            {renderableRequirements.length > 0 ? (
              renderableRequirements.map((requirement) => (
                <RequirementFieldRenderer
                  key={requirement.id}
                  requirement={requirement}
                  value={values[requirement.id]}
                  files={files}
                  prefillData={requirement._prefillData ?? null}
                  countryOptions={countryOptions}
                  kybCountriesLoading={kybCountriesLoading}
                  phoneCountryCode={phoneCountryCode}
                  phoneCountryOptions={phoneCountryOptions}
                  countriesLoading={countriesLoading}
                  country={country}
                  phoneError={phoneError}
                  getPhoneDialCode={getPhoneDialCode}
                  setPhoneCountryTouched={setPhoneCountryTouched}
                  setPhoneCountryCode={setPhoneCountryCode}
                  setPhoneError={setPhoneError}
                  updateValue={updateValue}
                  updateAddress={updateAddress}
                  handleFileChange={handleFileChange}
                  removeFile={removeFile}
                  handleUpdateMoreData={handleUpdateMoreData}
                />
              ))
            ) : (
              <p className="text-sm text-[#667085]">
                There are no pending information updates for this business.
              </p>
            )}

            {error && <p className="text-sm text-red-500">{error}</p>}

            {renderableRequirements.length > 0 && (
              <div className="flex justify-end pt-2">
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={!canSubmit || loading}
                  className={`rounded-lg px-6 !py-3 text-sm font-semibold ${
                    canSubmit && !loading
                      ? "bg-[#7F56D9] text-white hover:bg-[#6f00ff]"
                      : "bg-[#D8C5FF] text-white cursor-not-allowed"
                  }`}
                >
                  {loading ? <Loader /> : "Submit"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </OnboardingLayout>
  );
};

export default UpdateInformation;
